export default "__VITE_ASSET__CjHMv1c9__";